<template>
    <hp5-base-card padding-size-selection="md" is-elevated="true">
        <div class="clinic">
            <ResultsOnlineClinicImage :clinic="clinic" />
            <div class="clinic-info">
                <ResultsOnlineClinicHeader :clinic="clinic" />
                <ResultsOnlineClinicTagLines :clinic="clinic" />
                <ResultsOnlineClinicVirtualOfficeVisit :clinic="clinic" />
                <ResultsOnlineClinicStartVisitButton :clinic="clinic" />
            </div>
        </div>
    </hp5-base-card>
</template>

<script setup>

    const props = defineProps({
        clinic: Object
    })

</script>

<style scoped lang="scss">
@use '../../../assets/scss/breakpoints' as *;

.clinic {
    @include small-up {
        display: grid;
        grid-template-columns: auto 11fr;
        column-gap: var(--spacing-xs);
    }
}

</style>
